import {Chip, styled} from '@mui/material'
import type {ChipProps} from '@mui/material/Chip'

export const LinkChip = styled(Chip)<ChipProps>(({theme}) => ({
  '& .MuiChip-icon': {
    marginLeft: theme.spacing(1),
  },
}))
